/* eslint-disable react-hooks/rules-of-hooks */
import React, { lazy, Suspense } from 'react';

import SecuritySkeleton from '@/components/SecuritySkeleton';
import { useStore } from '@/store/useStore';
const LazyEnter = lazy(() => import('./lazyEntry'));

const index = () => {
  const { userInfoLoading } = useStore();

  return (
    <>
      {userInfoLoading && <SecuritySkeleton />}
      <Suspense fallback="">{!userInfoLoading && <LazyEnter />}</Suspense>
    </>
  );
};

export default index;
